export default `
<div>
  <p>
    <span style="text-decoration: underline">Dacă aveți o carte de identitate:</span>
    <span> vă rugăm să furnizați fotografii din față și din spate.</span>
  </p>
  <p>
    <span style="text-decoration: underline">Dacă aveți un pașaport:</span>
    <span> vă rugăm să furnizați fotografii ale tuturor paginilor cu informații personale (în două pagini pe fotografie).</span>
  </span>
  <p>
    Fotografiile trebuie să fie de bună calitate, colorate și ușor de citit. De asemenea, ștampilele și sigiliile ar trebui să fie vizibile.
  </p>
</div>
`;
